import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';



export default function Productos() {
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({nombre:'', descripcion:'', precio:'', precio_oferta:'', tiene_oferta:false, categoria_id:'', destacado:false, activo:true, marca:'', orden:0, compatibilidad:'', bci:''});
  const [foto, setFoto] = useState<File|null>(null);
  const [preview, setPreview] = useState('');
  const [subiendo, setSubiendo] = useState(false);
  const [marcasList, setMarcasList] = useState<any[]>([]);
  const [bciList, setBciList] = useState<any[]>([]);
  const [toast, setToast] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const cargar = () => {
    axios.get(`${API}/productos/`).then(r => setProductos(r.data));
    axios.get(`${API}/marcas/`).then(r => setMarcasList(r.data));
    axios.get(`${API}/bci/`).then(r => setBciList(r.data));
    axios.get(`${API}/categorias/`).then(r => setCategorias(r.data));
  };

  useEffect(() => { cargar(); }, []);

  const abrir = (p?: any) => {
    if (p) {
      setEditando(p);
      setForm({
        nombre:p.nombre, descripcion:p.descripcion||'', precio:p.precio||'',
        precio_oferta:p.precio_oferta||'', tiene_oferta:!!p.precio_oferta,
        categoria_id:p.categoria_id||'', destacado:p.destacado, activo:p.activo,
        marca:p.marca||'', orden:p.orden||0, compatibilidad:p.compatibilidad||'', bci:p.bci||''
      });
      setPreview(p.imagen_url ? `https://ticobaterias.com${p.imagen_url}` : '');
    } else {
      setEditando(null);
      setForm({nombre:'', descripcion:'', precio:'', precio_oferta:'', tiene_oferta:false, categoria_id:'', destacado:false, activo:true, marca:'', orden:0, compatibilidad:'', bci:''});
      setPreview('');
    }
    setFoto(null);
    setModal(true);
  };

  const seleccionarFoto = (e: any) => {
    const file = e.target.files[0];
    if (file) { setFoto(file); setPreview(URL.createObjectURL(file)); }
  };

  const guardar = async (e: any) => {
    e.preventDefault();
    setSubiendo(true);
    try {
      const data = {
        nombre: form.nombre, descripcion: form.descripcion,
        precio: parseFloat(form.precio as any),
        precio_oferta: form.tiene_oferta && form.precio_oferta ? parseFloat(form.precio_oferta as any) : null,
        categoria_id: parseInt(form.categoria_id as any) || null,
        destacado: form.destacado, activo: form.activo,
        marca: form.marca || null,
        orden: Number(form.orden),
        compatibilidad: form.compatibilidad || null,
        bci: form.bci || null
      };
      let productoId = editando?.id;
      if (editando) {
        await axios.put(`${API}/productos/${editando.id}`, data, { headers });
      } else {
        const res = await axios.post(`${API}/productos/`, data, { headers });
        productoId = res.data.id;
      }
      if (foto && productoId) {
        const fd = new FormData();
        fd.append('file', foto);
        await axios.post(`${API}/productos/${productoId}/imagen`, fd, { headers: {...headers, 'Content-Type':'multipart/form-data'} });
      }
      setModal(false);
      cargar();
      mostrarToast(editando ? '✅ Producto actualizado' : '✅ Producto creado');
    } catch (error: any) {
      if (error.response?.status === 401) {
        mostrarToast('⚠️ Tu sesión expiró, volvé a iniciar sesión');
      } else {
        mostrarToast('❌ Error al guardar');
      }
    } finally {
      setSubiendo(false);
    }
  };

  const eliminar = async (id: number) => {
    await axios.delete(`${API}/productos/${id}`, { headers });
    setConfirmId(null);
    cargar();
    mostrarToast('🗑️ Producto eliminado');
  };

  return (
    <div>
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">{toast}</div>
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Productos</h1>
          <p className="text-gray-500 text-sm">{productos.length} productos registrados</p>
        </div>
        <button onClick={() => abrir()} className="bg-azul text-white px-5 py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors">
          + Agregar producto
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">PRODUCTO</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">MARCA</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">CATEGORÍA</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">PRECIO</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">ORDEN</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">ESTADO</th>
              <th className="text-left px-6 py-4 text-xs font-bold text-gray-500 tracking-wider">ACCIONES</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {(productos as any[]).map((p: any) => (
              <tr key={p.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0">
                      {p.imagen_url ? <img src={`https://ticobaterias.com${p.imagen_url}`} className="w-full h-full object-cover" alt=""/> : <span className="text-2xl">🔋</span>}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        {p.nombre} {p.precio_oferta && <span>🔥</span>}
                      </div>
                      {p.destacado && <span className="text-xs bg-azul/10 text-azul px-2 py-0.5 rounded font-medium">Destacado</span>}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  {p.marca ? (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded font-medium">{p.marca}</span>
                  ) : <span className="text-gray-300 text-xs">—</span>}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  {(categorias as any[]).find((c: any) => c.id === p.categoria_id)?.nombre || '—'}
                </td>
                <td className="px-6 py-4">
                  {p.precio_oferta ? (
                    <div>
                      <div className="text-gray-400 text-xs line-through">₡{p.precio?.toLocaleString()}</div>
                      <div className="font-bold text-rojo text-sm">₡{p.precio_oferta?.toLocaleString()} 🔥</div>
                    </div>
                  ) : (
                    <span className="font-bold text-rojo text-sm">₡{p.precio?.toLocaleString()}</span>
                  )}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500 font-medium">{p.orden}</td>
                <td className="px-6 py-4">
                  <span className={`text-xs px-2 py-1 rounded-full font-bold ${p.activo ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                    {p.activo ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex gap-2">
                    <button onClick={() => abrir(p)} className="text-azul hover:bg-azul/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Editar</button>
                    <button onClick={() => setConfirmId(p.id)} className="text-rojo hover:bg-rojo/10 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors">Eliminar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {productos.length === 0 && (
          <div className="text-center py-16 text-gray-400">
            <div className="text-4xl mb-3">🔋</div>
            <p className="font-medium">No hay productos aún</p>
          </div>
        )}
      </div>

      {/* Modal confirmar eliminar */}
      {confirmId !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar producto?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmId(null)}
                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminar(confirmId)}
                className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal producto */}
      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-100">
              <h2 className="font-bold text-lg text-azul">{editando ? 'Editar producto' : 'Nuevo producto'}</h2>
            </div>
            <form onSubmit={guardar} className="p-6 space-y-4">
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">FOTO DEL PRODUCTO</label>
                <div onClick={() => fileRef.current?.click()}
                  className="border-2 border-dashed border-gray-200 rounded-xl p-4 text-center cursor-pointer hover:border-azul transition-colors">
                  {preview ? (
                    <img src={preview} alt="" className="h-32 mx-auto object-contain rounded-lg"/>
                  ) : (
                    <div className="py-4">
                      <div className="text-3xl mb-2">📷</div>
                      <p className="text-gray-400 text-sm">Clic para subir foto</p>
                      <p className="text-gray-300 text-xs mt-1">JPG, PNG — máx 5MB</p>
                    </div>
                  )}
                </div>
                <input ref={fileRef} type="file" accept="image/*" onChange={seleccionarFoto} className="hidden"/>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">NOMBRE</label>
                <input required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">DESCRIPCIÓN</label>
                <textarea value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                  rows={3} className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none"/>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">COMPATIBILIDAD (autos)</label>
                <textarea value={form.compatibilidad} onChange={e => setForm({...form, compatibilidad: e.target.value})}
                  rows={3} placeholder="Ej: Toyota Corolla 2005-2015, Honda Civic 2010-2020, Nissan Sentra..."
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none"/>
                <p className="text-xs text-gray-400 mt-1">Separá los modelos con comas. Esto mejora el buscador.</p>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">BCI</label>
                <select value={form.bci} onChange={e => setForm({...form, bci: e.target.value})}
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul">
                  <option value="">Sin código BCI</option>
                  {bciList.map((b:any) => (
                    <option key={b.id} value={b.codigo}>{b.codigo}{b.descripcion ? ` — ${b.descripcion}` : ''}</option>
                  ))}
                </select>
                <p className="text-xs text-gray-400 mt-1">Código BCI internacional del tipo de batería.</p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">PRECIO (₡)</label>
                  <input type="number" value={form.precio} onChange={e => setForm({...form, precio: e.target.value})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">CATEGORÍA</label>
                  <select value={form.categoria_id} onChange={e => setForm({...form, categoria_id: e.target.value})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul">
                    <option value="">Sin categoría</option>
                    {(categorias as any[]).map((c: any) => (
                      <option key={c.id} value={c.id}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">MARCA</label>
                  <select value={form.marca} onChange={e => setForm({...form, marca: e.target.value})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul">
                    <option value="">Sin marca</option>
                    {marcasList.map((m:any) => <option key={m.id} value={m.nombre}>{m.nombre}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">ORDEN</label>
                  <input type="number" min="0" value={form.orden} onChange={e => setForm({...form, orden: Number(e.target.value)})}
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
                </div>
              </div>

              {/* Oferta */}
              <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
                <label className="flex items-center gap-3 cursor-pointer mb-3">
                  <input type="checkbox" checked={form.tiene_oferta} onChange={e => setForm({...form, tiene_oferta: e.target.checked, precio_oferta: e.target.checked ? form.precio_oferta : ''})}
                    className="w-4 h-4 accent-orange-500"/>
                  <span className="font-bold text-orange-700 text-sm">🔥 Activar precio de oferta</span>
                </label>
                {form.tiene_oferta && (
                  <div>
                    <label className="text-xs font-bold text-orange-600 tracking-wider block mb-1.5">PRECIO DE OFERTA (₡)</label>
                    <input type="number" required value={form.precio_oferta} onChange={e => setForm({...form, precio_oferta: e.target.value})}
                      placeholder="Ej: 38000"
                      className="w-full border border-orange-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-orange-500 bg-white"/>
                    <p className="text-orange-500 text-xs mt-1">El precio original se mostrará tachado y el de oferta con animación 🔥</p>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-6">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={form.destacado} onChange={e => setForm({...form, destacado: e.target.checked})} className="w-4 h-4 accent-azul"/>
                  <span className="text-sm text-gray-600 font-medium">Producto destacado</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={form.activo} onChange={e => setForm({...form, activo: e.target.checked})} className="w-4 h-4 accent-azul"/>
                  <span className="text-sm text-gray-600 font-medium">Activo</span>
                </label>
              </div>
              <div className="flex gap-3 pt-2">
                <button type="submit" disabled={subiendo} className="flex-1 bg-azul text-white py-2.5 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors disabled:opacity-50">
                  {subiendo ? 'Guardando...' : editando ? 'Guardar cambios' : 'Crear producto'}
                </button>
                <button type="button" onClick={() => setModal(false)} className="px-6 border border-gray-200 rounded-xl text-gray-500 text-sm">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
